<template>
    <svg version="1.1"
         id="Layer_1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px"
         y="0px"
         viewBox="0 0 400 700"
         style="enable-background:new 0 0 400 700;"
         preserveAspectRatio="none"
         class="shape">
        <g>
            <polygon points="300,0 100,0 0,700 400,700"/>
        </g>
    </svg>
</template>

<script>
export default {};
</script>
